import { Tooltip } from 'antd'
import React, { useState } from 'react'


const Span = ({ text, styles = {}, className, ...props }) => {
  const [showTooltip, setShowTooltip] = useState(false)


  const handleOpenTooltip = (e) => {
    const width = e.target.offsetWidth
    const size = e.target.scrollWidth
    if (width - size < 0) {
      setShowTooltip(true)
    }
  }

  const handleCloseTooltip = (e) => {
    if (showTooltip) {
      setShowTooltip(false)
    }
  }

  return (
    <Tooltip visible={showTooltip} title={text}>
      <span style={{ display: 'inline-block', maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', ...styles }} onMouseEnter={handleOpenTooltip} onMouseLeave={handleCloseTooltip} onWheel={handleCloseTooltip} className={className} {...props}>
        {text}
      </span>
    </Tooltip>
  )
}

export default Span
